import React from 'react';

function RAGStatus( props ) {  
    return (<div className={'RAG-status-' + props.color + ' RAG-status-' + props.status }></div>);
}

export default RAGStatus;
